import { combineAllWatchers } from '@sonar-software/xuder';
import { combineReducers } from 'redux';
import { coreUsersCurrentPicturePutAsyncSlice } from './put';

export const coreUsersCurrentPictureReducers = combineReducers({
	put: coreUsersCurrentPicturePutAsyncSlice.asyncReducers
});

export const coreUsersCurrentPictureWatchers = combineAllWatchers([
	coreUsersCurrentPicturePutAsyncSlice.asyncWatchers
]);
